import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';

// A custom theme for this app
const theme = createMuiTheme({
  overrides: {
    MuiTableCell: {
        root: {  //This can be referred from Material UI API documentation. 
            padding: '6px 12px',
        },
    },
    TableCell: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '300px'
    },
},
  palette: {
    primary: {
      main: '#1863e6',
    },
    secondary: {
      main: green[500],
    },
    success: {
      main: green[500],
    },
    error: {
      main: red[500],
    },
    background: {
      default: '#F4F6F8',
    },
  },
});

export default theme;
